// 将每个国家的子包包名注入进去  用作国际化下拉切换显示判断

import { inject } from 'vue'
export function useSubpackageName() {
  const area = inject('name', null)
  return { area }
}
